module.exports = __webpack_public_path__ + "img/banner.4cfe01b9.png";